import { Button, Modal } from "antd";
import { svg } from "../Assets/svg";
import { title } from "process";
import FullScreenLoader from "../Admin/Components/FullScreenLoader";

interface Props {
  open: boolean;
  title: string;
  subTitle: string;
  loading?: boolean;
  confirmButtonText?: string;
  confirmButtonColorClass?: string;
  onSuccess: () => void;
  onClose: () => void;
  onlyCloseButton?: boolean;
  isContantLoading?: boolean;
}

export const CommonConfirmationModal: React.FC<Props> = ({
  open,
  onSuccess,
  onClose,
  title,
  subTitle,
  loading,
  confirmButtonText = "Remove",
  confirmButtonColorClass = "btn-red",
  onlyCloseButton = false,
  isContantLoading = false,
}) => {
  return (
    <Modal
      open={open}
      centered
      width={"33.75rem"}
      footer={null}
      onCancel={isContantLoading ? undefined : onClose}
      closeIcon={isContantLoading ? null : svg?.closeIcon}
      title={
        isContantLoading ? (
          ""
        ) : (
          <div className="text-center fs-4 fw-bolder lh-m">{title}</div>
        )
      }
      className="custom-modal"
    >
      {isContantLoading ? (
        <div style={{ height: "100%" }} className="d-flex flex-column align-items-center justify-content-center py-4">
          <FullScreenLoader />
          <p className="fs-6 mt-3 text-center">Please wait while opening default mail app...</p>
        </div>
      ) : (
        <>
          <div className="d-flex flex-column gap-2 align-items-center">
            <p className="fs-6 text-center">{subTitle}</p>
          </div>
          <div className="row gx-sm-4 gx-2 justify-content-center">
            <div className="col-sm-auto col-6">
              <Button
                onClick={onClose}
                className="btn btn-lg btn-outline-secondary w-100 h-auto px-sm-4"
              >
                CLOSE
              </Button>
            </div>
            {!onlyCloseButton && (
              <div className="col-sm-auto col-6">
                <Button
                  onClick={onSuccess}
                  className={`btn btn-lg w-100 ${confirmButtonColorClass} h-auto px-sm-5 text-uppercase`}
                  loading={loading}
                >
                  {confirmButtonText}
                </Button>
              </div>
            )}
          </div>
        </>
      )}
    </Modal>
  );
};
